import { useRoutes } from "react-router-dom";
import Loadable from "components/Loadable";
import { lazy } from "react";
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
const MaintenanceError = Loadable(lazy(() => import("components/error/404")));

// ==============================|| ROUTES RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    LoginRoutes,
    MainRoutes,
    { path: "*", element: <MaintenanceError /> },
  ]);
}
